import React from 'react'
import * as firebase from 'firebase'
import '../App.css'
import FirebaseStateComponent from '../common/FirebaseStateComponent.js'
import Spinner from '../common/Spinner.js'
import User from '../common/User.js'

export default class FriendsPage extends FirebaseStateComponent {
  constructor (props) {
    super(props)

    // Start with empty friends list
    this.state = {
      loading: true,
      friends: {}
    }

    // Add friends binding
    this.handleProps(props, false)
  }

  componentWillReceiveProps (nextProps) {
    // Process new props
    this.handleProps(nextProps)
  }

  handleProps (props, checkPrevious = true) {
    // Check if the new props contain the 'uid' value
    if (props.hasOwnProperty('uid') && props.uid !== null) {
      // Check if the value has changed
      if (!checkPrevious || !this.props.hasOwnProperty('uid') || this.props.uid !== props.uid) {
        this.addBinding('friends', 'friends/' + props.uid)
      }
    } else {
      // No new 'uid' value, remove user binding
      this.removeBinding('friends')
    }
  }

  getRenderedFriends () {
    if (this.state.loading) {
      return <Spinner />
    } else {
      const friends = this.state.friends

      if (friends === null || Object.keys(friends).length === 0) {
        return <div className='friends-list'>No friends</div>
      } else {
        const self = this
        const users = Object.keys(friends).map(function (uid, i) {
          const isYou = (uid === self.props.uid)
          return <User uid={uid} you={isYou} onRemove={self.createRemoveFriendTask} padding key={i} />
        })
        return <div className='friends-list'>{users}</div>
      }
    }
  }

  render () {
    const friends = this.getRenderedFriends()

    return (
      <div className='FriendsPage'>
        <h2>Friends</h2>
        {friends}
      </div>
    )
  }

  createRemoveFriendTask = (friendUid) => {
    console.log('Creating remove_friend task with friendUid: ' + friendUid)

    // Initialize firebase tasks reference on-demand
    if (this.tasksRef === undefined) {
      this.tasksRef = firebase.database().ref().child('queue/tasks')
    }

    // Push a new remove_friend task on the queue
    this.tasksRef.push({
      task: 'remove_friend',
      uid: this.props.uid,
      friendUid: friendUid
    })
  }
}



// WEBPACK FOOTER //
// ./src/pages/Friends.js